/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

function cleanJsonString(str) {
  return str
    // remove non-breaking spaces and other invisible chars
    .replace(/\u00A0/g, " ")
    // remove stray control characters
    .replace(/[\u0000-\u001F]+/g, " ")
    // collapse unnecessary spaces before closing tags
    .replace(/\s+<\/p>/g, "</p>");
}

  // Add custom code below this line
  if (document.querySelector('[data-variant_description-json]')) {
    const variantMetafieldsDescriptionData = document.querySelector('[data-variant_description-json]').textContent;
  //  const variantsMetafields = JSON.parse(variantMetafieldsDescriptionData);
    const variantsMetafields = JSON.parse(cleanJsonString(variantMetafieldsDescriptionData));
    document.querySelector('input[name="id"]').addEventListener('change', function (event) {
      let newVariantId = event.target.value;
      // console.log('changed', newVariantId);
      
          let variantDescHtml = '';
          variantsMetafields.forEach((variantMetafield) => {
            if (Number(variantMetafield.variant_id) === Number(newVariantId)) {
              // console.log('matched');
              
              variantDescHtml = variantMetafield.variant_description;    
              document.querySelector('.description_tab_pd').innerHTML = variantDescHtml;
              // console.log('updated');
              
            }
          });
    });
  }


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
